'use strict';

var G2iLogoSvg = require("./assets/partners/g2i-logo.svg");
var TuccLogoSvg = require("./assets/partners/tucc-logo.svg");
var AgentConfSvg = require("./assets/partners/agent-conf.svg");
var ScriptConfSvg = require("./assets/partners/script-conf.svg");
var ReactViennaSvg = require("./assets/partners/React-Vienna.svg");
var ReasonviennaSvg = require("./assets/partners/reasonvienna.svg");
var ReactFinlandSvg = require("./assets/partners/react-finland.svg");
var AccentureLogoSvg = require("./assets/partners/accenture-logo.svg");
var ImpacthubLogoPng = require("./assets/partners/impacthub-logo.png");
var JanestreetLogoSvg = require("./assets/partners/janestreet-logo.svg");
var ReactAmsterdamSvg = require("./assets/partners/react-amsterdam.svg");

var sponsors = /* array */[
  /* record */[
    /* name */"Accenture",
    /* logoUrl */AccentureLogoSvg,
    /* href */"https://www.accenture.com",
    /* tier : Gold */0
  ],
  /* record */[
    /* name */"JaneStreet",
    /* logoUrl */JanestreetLogoSvg,
    /* href */"https://www.janestreet.com",
    /* tier : Catering */1
  ],
  /* record */[
    /* name */"G2i",
    /* logoUrl */G2iLogoSvg,
    /* href */"https://g2i.co",
    /* tier : LocalSupport */2
  ]
];

var partners = /* array */[
  /* record */[
    /* name */"TU Career Center",
    /* logoUrl */TuccLogoSvg,
    /* href */"https://www.tucareer.com/",
    /* tier : Partner */3
  ],
  /* record */[
    /* name */"Impact Hub",
    /* logoUrl */ImpacthubLogoPng,
    /* href */"https://vienna.impacthub.net",
    /* tier : Partner */3
  ],
  /* record */[
    /* name */"Agent Conf",
    /* logoUrl */AgentConfSvg,
    /* href */"https://www.agent.sh/",
    /* tier : Partner */3
  ],
  /* record */[
    /* name */"React Amsterdam",
    /* logoUrl */ReactAmsterdamSvg,
    /* href */"https://react.amsterdam",
    /* tier : Partner */3
  ],
  /* record */[
    /* name */"React Finland",
    /* logoUrl */ReactFinlandSvg,
    /* href */"https://react-finland.fi",
    /* tier : Partner */3
  ],
  /* record */[
    /* name */"React Vienna",
    /* logoUrl */ReactViennaSvg,
    /* href */"https://www.meetup.com/ReactVienna/",
    /* tier : Partner */3
  ],
  /* record */[
    /* name */"ReasonVienna",
    /* logoUrl */ReasonviennaSvg,
    /* href */"https://www.meetup.com/Reason-Vienna/",
    /* tier : Partner */3
  ],
  /* record */[
    /* name */"Script Conf",
    /* logoUrl */ScriptConfSvg,
    /* href */"https://scriptconf.org",
    /* tier : Partner */3
  ]
];

exports.sponsors = sponsors;
exports.partners = partners;
/* sponsors Not a pure module */



// WEBPACK FOOTER //
// ./src/partners.js